import ls from "local-storage";
import { showMessage } from "../components/globals/Message";

/**
 * Para las peticiones estamos usando fetch ya que es nativo de JS, si bien
 * podemos cambiarlo a axios o algun otro servicio.
 */
const baseUrlAPI = process.env.REACT_APP_API_URL;
/**
 * Funcion publica para invocar las distintas peticones HTTP
 * @param {String} method Metodo HTTP
 * @param {String} enpoint Endpoint para la API
 * @param {Object} params Parametros de la peticion
 * @returns {object} response de la API
 * puede mejorar esto tal vez cachando la peticion 401 para no estar haciendolo en todos los llamados
 * y enviando el callback de lo que debe hacer al obtener la respuesta
 */
export async function apiCall(method = "GET", endpoint, params = {}) {
  switch (method) {
    case "GET":
      return await apiGET(endpoint);
    case "POST":
      return await apiPOST(endpoint, params);
    case "PUT":
      return await apiPUT(endpoint, params);
    case "DELETE":
      return await apiDELETE(endpoint);

    default:
      return {
        success: false,
        error: "Metodo HTTP no existe",
      };
  }
}

/**
 *
 * @param {string} endpoint es el metodo de la api que queremos ejecutar, los parametros deben ir incluidos en la cadena
 * @returns {Response}
 */
async function apiGET(endpoint) {
  //todas las petiicones incluyen el token en el header, la API es la que se encargar de procesar o ignorar
  //declaramos los headers
  let h = new Headers();
  h.append("Authorization", "Bearer " + ls.get("token")); //agregamos el token del local storage
  //declaramos la peticion
  let req = new Request(baseUrlAPI + endpoint, {
    method: "GET",
    headers: h,
  });
  //hacemos la peticion
  let result = await fetch(req)
    .then((res) => res.json())
    .then((res) => {
      return res; //regresamos el response, podemos interceptarlo desde aqui si se necesita hacer algo
    })
    .catch((e) => {
      console.error("API SERVER:", e);
      return false; //hay que mejorar la peticion fallida
    });
  return result;
}

/**
 *
 * @param {string} endpoint es el metodo de la api que queremos ejecutar
 * @param {object} params parametros que pasamos a la API
 * @returns {Response}
 */
async function apiPOST(endpoint, params = {}) {
  /**
   * Como el admin no tiene un proveedor asignado debemos enviar el proveedor actua como parametro
   * verificamos si el usuario es admin
   * agregamos el id_proveedor
   */
  if (ls.get("admin") === 1) {
    params = Object.assign(params, { id_proveedor: ls.get("id_proveedor") });
  }

  let h = new Headers();
  h.append("Authorization", "Bearer " + ls.get("token"));

  let req = new Request(baseUrlAPI + endpoint, {
    method: "POST",
    body: JSON.stringify(params),
    headers: h,
  });
  let result = await fetch(req)
    .then((res) => res.json())
    .then((res) => {
      preAccions(res);
      return res;
    })
    .catch((e) => {
      console.error("API SERVER:", e);
      return false;
    });
  return result;
}
async function apiPUT(endpoint, params = {}) {
  let h = new Headers();
  h.append("Authorization", "Bearer " + ls.get("token"));

  let req = new Request(baseUrlAPI + endpoint, {
    method: "PUT",
    body: JSON.stringify(params),
    headers: h,
  });
  let result = await fetch(req)
    .then((res) => res.json())
    .then((res) => {
      return res;
    })
    .catch((e) => {
      console.error("API SERVER:", e);

      return false;
    });
  return result;
}
async function apiDELETE(endpoint) {
  let h = new Headers();
  h.append("Authorization", "Bearer " + ls.get("token")); //agregamos el token del local storage
  //declaramos la peticion
  let req = new Request(baseUrlAPI + endpoint, {
    method: "DELETE",
    headers: h,
  });
  //hacemos la peticion
  let result = await fetch(req)
    .then((res) => res.json())
    .then((res) => {
      return res; //regresamos el response, podemos interceptarlo desde aqui si se necesita hacer algo
    })
    .catch((e) => {
      return false; //hay que mejorar la peticion fallida
    });
  return result;
}
//ahorita son alerts, deben ser messages
function preAccions(res) {
  switch (res.code) {
    case 400:
      showMessage("Fail: <br>" + res.message + "<br>" + res.data, "warning");
      break;
    case 401:
      showMessage("Session Expired, Please log in again.", "error");
      break;
    case 409:
      showMessage(
        "Wrong Params: <br>" + JSON.stringify(res.data) + "<br>" + res.message,
        "warning"
      );
      break;
    case 500:
      //qui solo puede caer si la api no cacha algun error
      showMessage("API server error: <br>" + res.message, "error");
      break;
    default:
      break;
  }
}
